module.exports = __webpack_public_path__ + "img/primary_10x2.a6a23f4a.svg";